<template>
    <div>
        推荐阅读
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>